<template>
  <div class="modifier-list">
    <template v-for="modifier in modifiersByGroup">
      <modifier-row @change="toggle" :modifier="modifier" :modifiers="modifiers"></modifier-row>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ModifierRow from './modifier-row.vue';

  export default {
    props: ['modifiers'],

    components: {
      ModifierRow
    },

    computed: {
      ...mapGetters([
        'active_module',
      ]),
      modifiersByGroup () {
        let filtered = [];

        this.modifiers.forEach((modifier, index) => {
          modifier.index = index;
          if (modifier.group) {
            const groupIndex = filtered.findIndex((m) => m.group === modifier.group);
            if (groupIndex >= 0) {
              filtered[groupIndex].partners.push(modifier);
            } else {
              modifier.partners = [];
              filtered.push(modifier);
            }
          } else {
            filtered.push(modifier);
          }
        });

        return filtered;
      }
    },

    methods: {
      ...mapActions([
        'add_to_active_modifiers',
        'remove_from_active_modifiers'
      ]),

      getPrice (index) {
        return this.modifiers[index].amount;
      },

      toggleDropdown (index, e) {
        console.log(e.target.value);
        this.add_to_active_modifiers({modifier_index: e.target.value});
      },

      toggle (index, checked = false) {
        console.log('toggle', index, checked);

        if (checked) {
          this.add_to_active_modifiers({modifier_index: index});
        } else {
          this.remove_from_active_modifiers({modifier_index: index});
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// modifier-list.vue?016625cf